export const ROAST_STATUS_LABELS = {
	start: '进行中',
	complete: '已完成',
	cancel: '已取消',
	delete: '已删除'
}

export const ROAST_STATUS_COLORS = {
	start: 'warning',
	complete: 'success',
	cancel: 'grey',
	delete: 'error'
}

export const ROAST_DEGREE_LABELS = {
	light: '浅烘',
	medium: '中烘',
	mediumdark: '中深烘',
	dark: '深烘',
	extradark: '极深烘'
}

/** 豆色从浅到深，与 RoastDegreeOrder 一致 */
export const ROAST_DEGREE_COLORS = {
	light: '#D7B899',
	medium: '#A67C52',
	mediumdark: '#6B4423',
	dark: '#3E2723',
	extradark: '#1A0F0A'
}

export function roastStatusLabel(status) {
	return ROAST_STATUS_LABELS[status] || status
}

export function roastDegreeLabel(degree) {
	return ROAST_DEGREE_LABELS[degree] || degree
}

export function roastDegreeColor(degree) {
	return ROAST_DEGREE_COLORS[degree] || '#9E9E9E'
}
